import React from 'react';
import { AppProvider } from '@/providers';
import { AppRoutes } from '@/routes';
import { message } from 'antd';
import './App.less';

message.config({
  maxCount: 1,
});

const App = () => {
  return (
    <AppProvider>
      <AppRoutes />
    </AppProvider>
  );
};

export default App;
